'use strict'
const youtubeVideoUtils = require('./youtubeVideoUtils')
const vimeoVideoUtils = require('./vimeoVideoUtils')
const dailymotionVideoUtils = require('./dailymotionVideoUtils')
const facebookVideoUtils = require('./facebookVideoUtils')
const _ = require('lodash');


// TODO: unite with santa viewer

const VIDEO_UTILS_PROVIDERS = {
  YOUTUBE: youtubeVideoUtils,
  VIMEO: vimeoVideoUtils,
  DAILYMOTION: dailymotionVideoUtils,
  FACEBOOK: facebookVideoUtils
}

function getMethodForType(videoType, methodName) {
  return VIDEO_UTILS_PROVIDERS[videoType.toUpperCase()] && VIDEO_UTILS_PROVIDERS[videoType][methodName]
}



/**
 * @param {{videoType: string, videoId: string}} videoData
 * @returns {string}
 */
function getVideoUrl(videoData) {
  if (videoData && videoData.videoType && videoData.videoId) {
    const videoUrlGetter = getMethodForType(videoData.videoType, 'getVideoUrl')
    return (videoUrlGetter && videoUrlGetter(videoData.videoId)) || ''
  }

  return ''
}

/**
 * @param {string} videoUrl
 * @returns {videoData}
 */
function getVideoDataFromUrl(videoUrl) {
  let videoData
  _.forEach(VIDEO_UTILS_PROVIDERS, function (methods, videoType) {
    const videoIdGetter = getMethodForType(videoType, 'getVideoIdFromUrl')
    const videoId = videoIdGetter && videoIdGetter(videoUrl)
    if (!_.isEmpty(videoId)) {
      videoData = {
        videoType,
        videoId
      }
      return false // break forEach
    }
  })
  return videoData
}

module.exports = {
  getVideoUrl,
  getVideoDataFromUrl,
  videoTypes: {
    YOUTUBE: 'YOUTUBE',
    VIMEO: 'VIMEO',
    DAILYMOTION: 'DAILYMOTION',
    FACEBOOK: 'FACEBOOK'
  }
}




// WEBPACK FOOTER //
// ./src/videoUrlsUtils/videoUrlsUtils.js